module.exports = __webpack_public_path__ + "assets/img/edge.438f35e5.svg";